import CryptoJS from "crypto-js";

import { API_KEY, ENABLE_CRYPTO, ENCRYPTION_KEY } from "../../constant/environment";
import { getUserTimezoneHeader } from "../userTimezone";

// function safeJsonParse(data: string) {
//   try {
//     const jsonString = JSON.parse(data);

//     if (typeof jsonString === "string") {
//       return JSON.parse(jsonString);
//     }

//     return jsonString;
//   } catch (error) {
//     return null;
//   }
// }
// Encrypt function
export function encryptData(data: any): string {
  if (ENABLE_CRYPTO === "false") {
    return JSON.stringify(data);
  } else {
    const stringifiedData = JSON.stringify(data); // Convert data to string
    return CryptoJS.AES.encrypt(stringifiedData, ENCRYPTION_KEY).toString();
  }
}

// Decrypt function
export function decryptData(encryptedData: string): any {
  if (ENABLE_CRYPTO === "false") {
    return JSON.stringify(encryptedData);
  } else {
    // Guard: return null for empty/invalid responses so callers can handle gracefully
    if (!encryptedData || typeof encryptedData !== "string") return null;
    try {
      const bytes = CryptoJS.AES.decrypt(encryptedData, ENCRYPTION_KEY);
      const decryptedData = bytes.toString(CryptoJS.enc.Utf8);
      if (!decryptedData) return null;
      return JSON.parse(decryptedData);
    } catch (err) {
      console.error("decryptData failed:", err);
      return null;
    }
  }
}

export function getHeaderConfig(signal: any, accessJWT: string) {
  // The traveller's own timezone. Spread rather than written inline because it
  // is CONDITIONAL — `{}` when the CORS flag is off or the browser reports no
  // usable zone, so the header is omitted entirely rather than sent blank. See
  // utils/userTimezone.ts for why the flag exists and how to turn it on.
  const userTimezone = getUserTimezoneHeader();
  if (signal)
    return {
      headers: {
        "x-api-key": API_KEY || "",
        "Content-Type": "text/plain",
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Headers": "*",
        "x-access-token": accessJWT,
        ...userTimezone,
      },
      signal,
      // timeout: 1000
    };
  return {
    headers: {
      "x-api-key": API_KEY || "",
      "Content-Type": "text/plain",
      "Access-Control-Allow-Origin": "*",
      "Access-Control-Allow-Headers": "*",
      "x-access-token": accessJWT,
      ...userTimezone,
    },
  };
}
